import { useRouteError } from "react-router-dom";
import { Logger } from "../logger";

let logger = new Logger(ErrorPage.name);

export default function ErrorPage() {
    const error: any = useRouteError();
    logger.error(error);

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
        </div>
    );
}